/* global theme, Shopify */

// T26: Called by instant.page only after its browser support checks pass.
// Reuse its eligibility rules and preloaded URL set; never intercept navigation.
theme.t26InitMenuPrefetch = (isPreloadable, preload) => {
  if (!window.IntersectionObserver || !window.MutationObserver) return;

  const desktop = window.matchMedia(theme.mediaQueries.md);
  let menu;
  let frame;
  const allowed = () => !desktop.matches && !Shopify.designMode
    && !navigator.connection?.saveData
    && !navigator.connection?.effectiveType?.includes('2g');
  const isOpen = () => menu?.isConnected
    && menu.querySelector('[data-t26-menu-prefetch-toggle][aria-expanded="true"]');
  const eligible = (link) => isPreloadable(link)
    && link.origin === location.origin
    && !link.hasAttribute('download')
    && (!link.target || link.target === '_self')
    && !/\/(?:cart|checkout|checkouts|account|discount)(?:\/|$)/i.test(link.pathname)
    && link.pathname + link.search !== location.pathname + location.search;

  const intersections = new IntersectionObserver((entries) => {
    if (!allowed() || !isOpen()) return;
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting && menu.contains(target) && eligible(target)
        && getComputedStyle(target).visibility === 'visible') {
        preload(target.href);
        intersections.unobserve(target);
      }
    });
  }, { threshold: 0.01 });

  const refresh = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      intersections.disconnect();
      if (!allowed() || !isOpen()) {
        mutations.disconnect();
        return;
      }
      // Read the current DOM, including renamed/new links and newly opened panels.
      menu.querySelectorAll('a[href]').forEach((link) => {
        if (eligible(link)) intersections.observe(link);
      });
    });
  };
  const mutations = new MutationObserver(refresh);

  // Delegation also handles a header replaced by section rendering. Only the
  // active menu is observed; closing it or clicking a replacement releases its observers.
  const connect = (current) => {
    if (!current) return;
    mutations.disconnect();
    intersections.disconnect();
    menu = current;
    if (allowed() && isOpen()) {
      mutations.observe(menu, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'style', 'aria-expanded', 'href', 'hidden', 'target', 'download', 'data-no-instant']
      });
    }
    refresh();
  };
  document.addEventListener('click', (event) => {
    connect(event.target.closest?.('[data-t26-menu-prefetch]'));
  }, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  // A fast first tap can precede the deferred scripts completing.
  connect(document.querySelector('[data-t26-menu-prefetch-toggle][aria-expanded="true"]')
    ?.closest('[data-t26-menu-prefetch]'));
};
